import type { Row } from "@rocicorp/zero";

export function activeTenantAdminUsers<
  T extends Pick<Row["user"], "id" | "deactivated">,
>(grants: readonly { user?: T | null }[]): T[] {
  return [
    ...new Map(
      grants.flatMap(({ user }) =>
        user && !user.deactivated ? [[user.id, user] as const] : []
      )
    ).values(),
  ];
}
